import { useQuery } from '@tanstack/react-query'

import { ApiError } from '@/lib/apiErrors'
import { toI18nKey } from '@/lib/toI18nKey'
import { useIsDineInSession } from '@/hooks/useIsDineInSession'
import { getMenuItems } from '@/shared/api/menu'

export function useMenuItems(ref: string, scheduleId: string) {
	const isDineIn = useIsDineInSession()
	const query = useQuery({
		// isDineIn is not part of the key, so the first fetch must already have the right value.
		queryKey: ['menu', 'items', ref, scheduleId],
		queryFn: () => getMenuItems(ref, scheduleId, isDineIn),
		enabled: ref !== '' && scheduleId !== '',
	})

	const errorKey =
		query.error != null
			? toI18nKey('olo:menu', query.error instanceof ApiError ? query.error.code : 'UNKNOWN')
			: null

	return { ...query, errorKey }
}
